export var NAME = 'BvConfig';
export var PROP_NAME = '$bvConfig';
export var DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/constants/config.js
// module id = ./node_modules/bootstrap-vue/esm/constants/config.js
// module chunks = 0